import React from 'react'
import Select from 'react-select'

function ReactSelect({ label, options, isMulti, onChange, value, customStyles, labelClass, inputClass, id, ...rest }) {
  
  const selectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'white' : '#1a3b5c',
        backgroundColor: state.isSelected ? '#006bb7' : '',
        ':hover': {
          backgroundColor: state.isSelected ? '#006bb7' : '#006bb725',
        }
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#f2f4f6',
      outline: state.isFocused ? '0px solid red' : '',
      outlineOffset: state.isFocused ? '16px' : '8px',
      borderRadius: '0.25rem',
      fontSize: '0.85rem',
      lineHeight: 1,
      paddingTop: '0.35rem',
      paddingBottom: '0.35rem',
      paddingLeft: '0.75rem',
      marginTop: '0.5rem',
      borderStyle: 'none',
      boxShadow: 'none'
    }),
    placeholder: () => ({
      color: '#9ea4b0'
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#1a3b5c',
      lineHeight: '1.25',
      marginTop: '1px'
    }),
  };
  
  return (
    <>
      <label id={id} className={`my-auto font-semibold text-secondary ${labelClass}`}>{ label }</label>
      <div className={`${inputClass}`}>
        {!isMulti && <Select options={options} styles={customStyles ? customStyles : selectStyles} value={{label: value}} onChange={onChange} { ...rest } />}
        {isMulti && <Select options={options} styles={customStyles ? customStyles : selectStyles} isMulti onChange={onChange} { ...rest } />}
      </div>
    </>
  )
}

export default ReactSelect
